document.addEventListener("DOMContentLoaded", () => {

  const body = document.body;
  const overlay = document.querySelector(".sub-view-overlay");
  // Open Sub Category
  document.querySelectorAll(".cat-circ").forEach((item) => {

    item.addEventListener("click", function () {

      const target = this.dataset.target;
      const panel = document.getElementById(target);

      if (!panel) return;

      // Close all panels first
      document.querySelectorAll(".sub-view").forEach((view) => {
        view.classList.remove("active");
      });

      panel.classList.add("active");
      overlay.classList.add("active");
      body.classList.add("overflow-hidden");

    });

  });

  // Close Button
  document.querySelectorAll(".back-btn").forEach((btn) => {

    btn.addEventListener("click", function () {

      const panel = this.closest(".sub-view");

      panel.classList.remove("active");
      overlay.classList.remove("active");
      body.classList.remove("overflow-hidden");

    });

  });
  overlay.addEventListener("click", function () {

    document.querySelectorAll(".sub-view").forEach(function(panel) {
      panel.classList.remove("active");
    });

    overlay.classList.remove("active");
    body.classList.remove("overflow-hidden");

  });
  // ESC Key Support
  document.addEventListener("keydown", function (e) {

    if (e.key === "Escape") {

      document.querySelectorAll(".sub-view").forEach((panel) => {
        panel.classList.remove("active");
      });
      overlay.classList.remove("active");
      body.classList.remove("overflow-hidden");

    }

  });

});
